var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtGym(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 119.6,
    cy: 86.1,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,16.5c1-1,1.5-2.3,1.5-3.6s-0.5-2.6-1.5-3.6c-1-1-2.3-1.5-3.6-1.5c-1.3,0-2.6,0.5-3.6,1.5L60,50.9H10.6 c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1h53.7L109,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.3,125.9V86.9L137,50.3c2-2,2-5.3,0-7.3c-2-2-5.3-2-7.3,0l-25.5,25.5l-20-20L67.9,64.8L90,87v38.9H30.7 c-5.7,0-10.4,4.7-10.4,10.4v7.7h2.7v-7.7c0-4.2,3.4-7.6,7.6-7.6H144v-2.7L100.3,125.9L100.3,125.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtGym);
export default __webpack_public_path__ + "static/media/artGym.7ea5ca7112659245c3bf12dfd9c1e569.svg";
export { ForwardRef as ReactComponent };